// extracted by mini-css-extract-plugin
module.exports = {"carousel-img":"RWn_a","container":"_3P_I0","thumb":"_1IGnj","thumb-active":"_19AGE","big":"_2fjOp","active":"sFWlP"};